import { Toast } from "@capacitor/toast";

const URL_BASE = "https://y2i44jhb22.execute-api.sa-east-1.amazonaws.com/prd"
//const URL_BASE = "http://localhost:3000/prd";

export const ambiente = "prd"

// ========================================
// MARKETING & CONVERSÕES (Meta Pixel + CAPI + GA4)
// ========================================
export const marketingConfigPublica = { url: URL_BASE + "/mobile/empresas/{id}/configuracao/marketing", method: "GET" };
export const analyticsCapiEnviar = { url: URL_BASE + "/mobile/analytics/event", method: "POST" };

//Sobre Usuario
export const enviarEmail = { url: URL_BASE + "/mobile/usuario/{cpf}/autenticacao/email", method: "POST" };
export const onboarding_all = { url: URL_BASE + "/mobile/onBoarding/v1?onBoarding=1", method: "GET" };
export const usuarioCadastrar = { url: URL_BASE + "/mobile/usuario", method: "POST" };
export const usuarioAlterar = { url: URL_BASE + "/mobile/usuario", method: "PUT" };
export const usuarioCarregar = { url: URL_BASE + "/mobile/usuario", method: "GET" };
export const usuarioAtualizarChaveContato = { url: URL_BASE + "/mobile/usuario", method: "PATCH" };
export const usuarioAtualizarLocalizacao = { url: URL_BASE + "/mobile/usuario/localizacao", method: "PATCH" };
export const placaExcluir = { url: URL_BASE + "/usuario/{cpf}/veiculos", method: "DELETE" };
export const placaCadastrar = { url: URL_BASE + "/usuario/{cpf}/veiculos", method: "POST" };
export const confirmarCadastro = { url: URL_BASE + "/mobile/usuario/confirmar", method: "POST" };
export const logar = { url: URL_BASE + "/mobile/usuario/logar", method: "POST" };
export const deslogar = { url: URL_BASE + "/mobile/usuario/deslogar", method: "POST" };
export const confirmarLogin = { url: URL_BASE + "/mobile/usuario/logar/otp", method: "POST" };
export const cadastrarELogarDireto = { url: URL_BASE + "/mobile/usuario/cadastrar-logar", method: "POST" };
export const verificaLogin = { url: URL_BASE + "/echoLogado", method: "GET" };
export const autenticado = { url: URL_BASE + "/mobile/autenticado", method: "POST" };
export const usuarioExcluir = { url: URL_BASE + "/mobile/usuario/{id}", method: "DELETE" };

//Sobre Empresas
export const listarEmpresa = { url: URL_BASE + "/empresa", method: "GET" };

//Sobre Operacoes
export const iniciarOperacao = { url: URL_BASE + "/operacao", method: "POST" };
export const avaliarOperacao = { url: URL_BASE + "/mobile/operacao/", method: "PUT" };
export const encerrarOperacao = { url: URL_BASE + "/operacao", method: "PUT" };
export const listaOperacao = { url: URL_BASE + "/mobile/operacao", method: "GET" };
export const listaOperacaoPorStatus = { url: URL_BASE + "/mobile/operacao/status/{status}", method: "GET" };
export const carregaOperacao = { url: URL_BASE + "/mobile/operacao/", method: "GET" };
export const clienteCarregar = { url: URL_BASE + "/clientes/{id}", method: "GET" };

export const incluirOcorrenciaOperacao = { url: URL_BASE + "/operacao", method: "PATCH" };
export const incluiNotaFiscal = { url: URL_BASE + "/operacao/{id}/notas", method: "POST" };
export const iniciarOperacaoAvulsa = { url: URL_BASE + "/avulsas", method: "POST" };

export const listaAgendamento = { url: URL_BASE + "/mobile/agendamento", method: "GET" };
export const carregaAgendamento = { url: URL_BASE + "/mobile/agendamento/", method: "GET" };

export const listaProjeto = { url: URL_BASE + "/mobile/ordens", method: "GET" };
export const carregaProjeto = { url: URL_BASE + "/mobile/ordens/", method: "GET" };
export const listaConvidados = { url: URL_BASE + "/mobile/ordens/convidado", method: "GET" };
export const avaliarProjeto = { url: URL_BASE + "/mobile/ordens/", method: "PUT" };
export const assinarArquivoProjeto = { url: URL_BASE + "/mobile/ordens/{id}/arquivo", method: "POST" };
export const carregaAssinatura = { url: URL_BASE + "/mobile/assinatura/{id}", method: "GET" };

export const buscarServicos = { url: URL_BASE + "/mobile/empresa", method: "POST" };



export const listaEmpresa = { url: URL_BASE + "/mobile/empresa", method: "GET" };

export const buscarSugestoesLocalizacao = { url: URL_BASE + "/mobile/localizacao/sugestoes?texto={texto}", method: "GET" };
export const buscarDetalhesLocalizacao = { url: URL_BASE + "/mobile/localizacao/detalhes?placeId={placeId}", method: "GET" };
export const buscarEmpresasProximas = { url: URL_BASE + "/mobile/empresas/proximas", method: "POST" };

export const marcaLojasCarregar = { url: URL_BASE + "/mobile/marca/{id}", method: "GET" };


export const urlBase = { url: URL_BASE, method: "GET" };

export const agendamentoProjetoCarregar = { url: URL_BASE + "/mobile/agendamento/projeto/{projetoid}", method: "GET" };
export const operacaoProjetoCarregar = { url: URL_BASE + "/mobile/operacao/projeto/{projetoid}", method: "GET" };

export const listarMensagensCliente = { url: URL_BASE + "/mobile/notificacoes/{id}", method: "GET" };
export const enviarMensagemCliente = { url: URL_BASE + "/mobile/notificacoes/{id}", method: "POST" };
export const removerNotificacao = { url: URL_BASE + "/mobile/notificacoes/{id}", method: "PUT" };

export const empresaCarregar = { url: URL_BASE + "/mobile/empresa/{id}", method: "GET" };
export const cashbackCarregar = { url: URL_BASE + "/mobile/cashback/{id}", method: "GET" };
export const buscarEndereco = { url: URL_BASE + "/mobile/empresa/{id}/endereco/{endereco}", method: "GET" };
export const buscarPlaces = { url: URL_BASE + "/mobile/empresa/{id}/places/{endereco}", method: "GET" };
export const buscarPlaceDetails = { url: URL_BASE + "/mobile/empresa/{id}/places-details/{placeId}", method: "GET" };

export const incluirProjeto = { url: URL_BASE + "/mobile/ordens/pedido", method: "POST" };
export const armazenarProjeto = { url: URL_BASE + "/mobile/ordens/armazenar", method: "POST" };
export const carrinhoSugestoes = { url: URL_BASE + "/mobile/carrinho/sugestoes", method: "POST" };
export const carrinhoValidar = { url: URL_BASE + "/mobile/carrinho/validar", method: "POST" };

export const pagamentoPedido = { url: URL_BASE + "/mobile/ordens/{id}/pagamento", method: "POST" };
export const consultaPagamentoPedido = { url: URL_BASE + "/mobile/ordens/{id}/pagamento", method: "GET" };


//export const listaOperacaoCompartilhada = {url: URL_BASE+"/operacao/compartilhada", method: "GET"};

export async function getJSONObject(url: string) {
  const response = await fetch(url);
  const myJson = await response.json();
  return myJson;
}

export async function requestService(url: any, config: any, history: any, callbackSuccess: any, callbackError: any, redirectLogin?: boolean, getStatus?: boolean) {
  //console.log("call api");
  //console.log(url);
  //console.log(config);
  //console.log(history);

  const timeoutId = setTimeout(() => {
    Toast.show({
      text: 'Sua conexão está lenta. Isto pode demorar um pouco. Tente melhorar o sinal.',
      duration: "long"
    });
  }, 20000);

  // inclui a versão no cabecalho de todas as chamadas
  if (config) {
    const defaults = {
      token: localStorage.getItem("token") || "",
      versao: localStorage.getItem("versao") || "",
      perfil: localStorage.getItem("perfil") || "",
      marca: localStorage.getItem("marca") || "",
    };

    const headers =
      Array.isArray(config.headers)
        ? Object.fromEntries(config.headers)
        : (config.headers || {});

    config.headers = { ...defaults, ...headers };

    // console.log("config.headers", config.headers);
  }

  return await fetch(url, config).then(res => {
    if (res.status === 426) {
      history.replace("/atualizar");
    } else if (res.status === 401 && (redirectLogin || redirectLogin === undefined)) {
      if (history)
        history.replace("/primeiroacesso");
      res.json().then(response => {
        response.status = res.status;
        callbackError(response);
      });
    } else if (res.status === 200 || res.status === 201) {
      res.json().then(response => {
        if (getStatus)
          response.status = res.status
        callbackSuccess(response);
      });
    } else {
      res.json().then(response => {
        response.status = res.status;
        callbackError(response);
      });
    }
  }).catch(async (err) => {
    await Toast.show({
      text: 'Sua conexão está muito lenta. Verifique seu sinal e tente novamente.',
      duration: "long"
    });
    err.xeguei = 444;
    callbackError(err);
  }).finally(() => { clearTimeout(timeoutId) });
}
